function About() {
    return (
        <div className="container content"> 
            <h1 style={{textAlign: "center", color: "white"}}>О нас</h1>
            <section style={{color: "white"}}>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo nisi eaque itaque incidunt. Excepturi sapiente molestias aperiam iure vero maxime dolore, ad iusto voluptatem commodi. Officiis nemo sint voluptatem inventore?</p>
            </section>

            <br />

            <section style={{color: "white"}}>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo nisi eaque itaque incidunt. Excepturi sapiente molestias aperiam iure vero maxime dolore, ad iusto voluptatem commodi. Officiis nemo sint voluptatem inventore?</p>
            </section>
        </div>
        
    )
}

export default About;